import { Directive, ElementRef, HostBinding, AfterViewInit, OnInit, Renderer2 } from '@angular/core';

import { CartPopupService } from '../cart-popup.shared.service';

@Directive({
    selector: '[directive-cart-indicator]',
})
export class CartIndicatorDirective implements AfterViewInit, OnInit {
    private _elem: HTMLElement;

    @HostBinding('style.left.px') public left: string = null;
    @HostBinding('style.width.px') public width: string = null;

    constructor(
        private _elementRef: ElementRef,
        private _cartPopupService: CartPopupService,
        private _renderer2: Renderer2
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

    }

    ngAfterViewInit(): void {
        this._setPosition();
    }

    private _unsetStyles(): void {
        this.left = null;
        this.width = null;
    }

    private _setPosition(): void {
        const offset = this._cartPopupService.offset;
        setTimeout(() => {
            if (window.innerWidth < 768) {
                return this._unsetStyles();
            }

            const target: ClientRect = this._cartPopupService.getTargetCoords();
            if (!target) {
                return this._unsetStyles();
            }

            const outerWidth = this._elem.parentElement.clientWidth;
            //const stickToRight: boolean = (target.left + outerWidth + offset) < window.innerWidth;

            //if (stickToRight) {
            this.left = `${outerWidth - offset - target.width}`;
            // } else {
            //     this.left = `${offset}`;
            // }

            this.width = `${target.width}`;
        }, 0);
    }
}
